import { A4uAlert as IconComponent } from '@adobe/react-spectrum-workflow/dist/Alert.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Alert(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}